import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Self-hosted type. Inter (body), Inter Tight (display), IBM Plex Mono (metadata).
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter-tight/800.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
